<template>
  <div class="CategoriasListado">
    <div v-if="isOnline">
      <md-table
        v-model="filtro_categorias"
        md-sort="nombre_ces"
        md-sort-order="asc"
        md-fixed-header
        md-card
      >
        <md-table-toolbar>
          <div class="md-toolbar-section-start md-title">Jurisdicciones de escuelas</div>
          <div class="md-toolbar-section-end">
            <md-field md-clearable>
              <md-input
                placeholder="Buscar jurisdicción..."
                v-model="buscar"
              />
            </md-field>
            <md-button
              class="md-icon-button"
              @click="showDialogFormCes = true"
            >
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          class="upper"
        >
          <md-table-cell
            md-label="Nombre"
            md-sort-by="nombre_ces"
          >
            {{item.nombre_ces}}
          </md-table-cell>
          <md-table-cell md-numeric>
            <md-button
              class="md-icon-button md-dense"
              @click="_editarCategoria(item)"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <md-progress-bar
        md-mode="indeterminate"
        class="md-accent"
        v-if="cargando"
      />

      <md-dialog :md-active.sync="showDialogFormCes">
        <md-dialog-title>{{categoria.id ? 'Editar':'Registrar'}} jurisdicción</md-dialog-title>
        <md-dialog-content>
          <md-field>
            <label>Nombre de la jurisdicción</label>
            <md-input v-model="categoria.nombre_ces" />
          </md-field>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button @click="showDialogFormCes=false">Cancelar</md-button>
          <md-button
            class="md-raised md-primary"
            @click="_presave()"
          >
            {{categoria.id ? 'Actualizar':'Guardar'}}
          </md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
    <InternetRequired v-else />
  </div>
</template>

<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarCes = (items, term) => {
  if (term) {
    return items.filter(item =>
      toLower(item.nombre_ces).includes(toLower(term))
    );
  }
  return items;
};
import InternetRequired from "@/components/InternetRequired";
export default {
  name: "CategoriasListado",
  components: { InternetRequired },
  methods: {
    buscarEnLaTabla() {
      this.filtro_categorias = buscarCes(this.escuelas, this.buscar);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerCategorias() {
      this.$http.get("categorias", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "categorias" in res.body) {
            this.categorias = res.body.categorias;
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    },
    _validateCategoria() {
      this.errores.nombre_ces = this.$mdError(this.categoria.nombre_ces);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validateCategoria()) {
        this.categoria.id ? this._updateCategoria() : this._saveCategoria();
      } else {
        this.$emit("msg", this.$llene_campos);
      }
    },
    _saveCategoria() {
      this.$http
        .post("categorias", { categoria: this.categoria }, this.$headers)
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 201 && "id" in res.body) {
              this.categorias.push({
                id: res.body.id,
                id_ces: res.body.id_ces,
                nombre_ces: this.categoria.nombre_ces
              });
              this.showDialogFormCes = false;
              this.$emit("msg", res.body.msg);
            } else {
              this.$emit(
                "msg",
                "Sucedió un error al guardar la categoría. Inténtelo de nuevo."
              );
            }
          },
          err => this._falloResponse(err)
        );
    },
    _updateCategoria() {
      this.$http
        .put(
          "categorias/" + this.categoria.id,
          { categoria: this.categoria },
          this.$headers
        )
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 200) {
              let a = this.categoria.id;
              let i = this.categorias.findIndex(function(b) {
                return b.id === a;
              });
              if (i >= 0) {
                this.categorias[i].nombre_ces = this.categoria.nombre_ces;
              }
              this.$emit("msg", res.body.msg);
              this.showDialogFormCes = false;
            } else {
              this.$emit(
                "msg",
                "Sucedió un error al actualizar la categoría. Inténtelo de nuevo."
              );
            }
          },
          err => this._falloResponse(err)
        );
    },
    _editarCategoria(a) {
      this.categoria.id = a.id;
      this.categoria.id_ces = a.id_ces;
      this.categoria.nombre_ces = a.nombre_ces;
      this.showDialogFormCes = true;
    }
  },
  data() {
    return {
      cargando: false,
      showDialogFormCes: false,
      buscar: null,
      categorias: [],
      categoria: {
        id: null,
        id_ces: null,
        nombre_ces: null
      },
      errores: {
        nombre_ces: null
      },
      filtro_categorias: []
    };
  },
  watch: {
    categorias() {
      this.filtro_categorias = this.categorias;
    },
    buscar(a) {
      this.buscarEnLaTabla();
    }
  },
  created() {
    this._obtenerCategorias();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  computed: {
    networkStatus() {
      let a = this.isOnline ? true : false;
      return a;
    }
  }
};
</script>
